import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const devices = [
	{ code: "NT", name: "Netatmo", description: "Indoor climate and thermostat monitoring.", to: "/devices/netatmo" },
	{ code: "VA", name: "Voltaware", description: "Household electrical consumption insights.", to: "/devices/voltaware" },
	{ code: "AT", name: "Aton", description: "Photovoltaic production and battery storage.", to: "/devices/aton" },
	{ code: "BT", name: "BTicino", description: "Smart meter, lighting and connected outlets.", to: "/devices/bticino" },
	{ code: "ZC", name: "Zucchetti", description: "Photovoltaic inverter production and operating status.", to: "/devices/zucchetti" },
	{ code: "SH", name: "Shelly Smart Plug", description: "Connected loads and real-time power status.", to: "/devices/smartplug" },
	{ code: "WD", name: "Washer-dryer", description: "Appliance status and washing-cycle events.", to: "/devices/washerdryer" },
	{ code: "SG", name: "Smart Garden", description: "Husqvarna robotic mower and garden activity.", to: "/devices/husqvarna" },
];

const DevicesPage = () => (
	<div className="right_col" role="main">
		<header className="page-heading">
			<div>
				<p className="eyebrow">CONNECTED ECOSYSTEM</p>
				<h1>Devices</h1>
				<p>Explore the cloud-to-cloud integrations connected to the Domus IoT platform.</p>
			</div>
			<span className="page-badge">{devices.length} integrations</span>
		</header>

		<section className="device-grid" aria-label="Connected device integrations">
			{devices.map((device) => (
				<Link className="device-card" to={device.to} key={device.to}>
					<span className="device-card__icon" aria-hidden="true">{device.code}</span>
					<div>
						<h2>{device.name}</h2>
						<p>{device.description}</p>
					</div>
					<FontAwesomeIcon className="device-card__arrow" icon={faArrowRight} aria-hidden="true" />
				</Link>
			))}
		</section>
	</div>
);

export default DevicesPage;
